import { useAuthStore } from "../state/auth";
// Completed 3D worlds (World Labs / Marble) keyed by checkpoint.
// Powers the 3D globe icon shown next to checkpoints in Live Activity.

export interface SpatialWorld {
  checkpoint_id: string;
  marble_url: string;
  splat_url?: string | null;
  status: string;
  completed_at?: string | null;
}

/**
 * Fetches completed spatial worlds for a hospital and returns them as a map
 * keyed by checkpoint_id for O(1) lookup while rendering scan rows.
 */
export async function fetchCompletedWorlds(hospitalId?: string): Promise<Map<string, SpatialWorld>> {
  const map = new Map<string, SpatialWorld>();
  if (!hospitalId) return map;

  try {
    const url = new URL("/api/captures/worlds", window.location.origin);
    url.searchParams.append("hospital_id", hospitalId);

    const token = useAuthStore.getState().token;
    const res = await fetch(url.toString(), {
      cache: "no-store",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) return map;

    const data: SpatialWorld[] = await res.json();
    for (const world of data) {
      if (world.checkpoint_id && world.marble_url) {
        map.set(world.checkpoint_id, world);
      }
    }
  } catch (err) {
    console.error("fetchCompletedWorlds failed:", err);
  }
  return map;
}
